import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CrudService} from '../crud.service';

@Injectable({
  providedIn: 'root'
})
export class CareersService extends  CrudService{

  constructor(
      httpClient: HttpClient
  ) {
      super(httpClient, 'careers');
  }
}
